





























import { defineComponent, ref } from '@vue/composition-api';
import TransliterationInformationCard from '@/views/Search/TextsSearch/components/TransliterationInformationCard.vue';
import TextNameInformationCard from '@/views/Search/TextsSearch/components/TextNameInformationCard.vue';
export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    textNameDisplayHelp: {
      type: Boolean,
      default: false,
    },
    transliterationDisplayHelp: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TransliterationInformationCard,
    TextNameInformationCard,
  },
  setup() {
    const helpOpen = ref(false);

    return {
      helpOpen,
    };
  },
});
